import React, { ReactNode } from 'react';
import Cabecalho from '../../components/layout/cabecalho/cabecalho';
import Rodape from '../../components/layout/rodape/rodape';
import { Helmet } from 'react-helmet';
import './layoutRodapeCabecalho.css';

interface LayoutCabecalhoRodapeProps {
  children: ReactNode;
}

const LayoutCabecalhoRodape: React.FC<LayoutCabecalhoRodapeProps> = ({ children }) => {
  return (
    <div className="grid-container">
      <Helmet>
        <link rel="icon" href="./favicon.svg" type="image/svg+xml" />
      </Helmet>
      <Cabecalho />
      <main className="main content">
        {children}
      </main>
      <Rodape />
    </div>
  );
}

export default LayoutCabecalhoRodape;
